import { useCallback } from "react";
import { useApi } from "../api";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";
import type { ScrewConnectorReportData } from "./types/report";

const getScrewConnectorReportUrl = (calculationId: string): string => `${SCREW_CONNECTOR_URL}/${calculationId}/report`;

/**
 * Renders the PDF report of a Screw Connector calculation on the server, in data.language: as a blob object URL for
 * the inline preview and printing. Only for users who can read the calculation, or admins.
 */
export const useScrewConnectorReportApi = () => {
  const api = useApi();

  const getScrewConnectorReport = useCallback(
    (calculationId: string, data: ScrewConnectorReportData): Promise<string> =>
      api.postForFileObjectUrl(getScrewConnectorReportUrl(calculationId), data),
    [api],
  );

  return { getScrewConnectorReport };
};
